export const GET_ALL_CAMPAIGNS = "GET_ALL_CAMPAIGNS"
export const GET_ALL_CAMPAIGNS_RESPONSE_SUCCESS =
  "GET_ALL_CAMPAIGNS_RESPONSE_SUCCESS"
export const CREATE_CAMPAIGN = "CREATE_CAMPAIGN"
export const UPDATE_CAMPAIGN = "UPDATE_CAMPAIGN"
export const DELETE_CAMPAIGN = "DELETE_CAMPAIGN"
